module.exports = __webpack_public_path__ + "img/icebath.17ea0ea6.jpg";